import axios from 'axios';
import * as CONFIG from '../config/index';
export const ROLE_API_URL = `${CONFIG.API_URL}/role`
import * as helper from './helper'

export const search = async (condition, pageNo, pageSize) => {
  try {
    const result = await axios.get(`${ROLE_API_URL}/search?condition=${condition}&pageNo=${pageNo}&pageSize=${pageSize}`);
    return result.data.data;
  } catch (e) {
    helper.notifyError(e);
    return {items: [], totals: 0};
  }
}

export default {
  search: search
}



// WEBPACK FOOTER //
// ./src/common/role.js